import { ITaskData } from "common/records/Task";
import { task as taskSelector } from "common/selectors/task.selectors";
import { store } from "common/store";
import { SUCCESS, DANGER, addFlashAlert } from "common/components/FlashAlert";
import { TaskActions } from "common/reducers/task.actions";
import { TaskContextRecord } from "common/records/TaskContext";
import { titleCaseString } from "common/helpers/String";

export const syncTask = async (taskData: ITaskData): Promise<void> => {
  const task = await taskSelector(store.getState(), { taskId: taskData.id });

  if (task?.context) {
    switch (taskData.status) {
      case "finished":
        await handleTaskSuccess(taskData, task.context);
        break;
      case "error":
        handleTaskError(taskData, task.context);
        break;
      default:
        break;
    }
    store.dispatch(TaskActions.receiveTask({ ...taskData, context: task.context?.toJS() }));
  }
};

export const handleTaskSuccess = async (taskData: ITaskData, context: TaskContextRecord) => {
  if (context.model && context.action) {
    try {
      await dispatchContextAction(taskData, context.model, context.action, context.action_payload);
    } catch (error: any) {
      console.error("Error in dispatching function dynamically:", error?.message);
    }
  } else {
    const name = taskData.results.class_name || "Task Completion";
    addFlashAlert(SUCCESS, `${name} Successful.`);
  }
};

export const handleTaskError = async (taskData: ITaskData, context: TaskContextRecord) => {
  if (context.model && context.error_action) {
    await dispatchContextAction(taskData, context.model, context.error_action, context.action_payload);
  } else {
    const errorMessage =
      taskData?.results?.error_message ||
      "There were problems processing your task. Please try again. If the problem persists contact support.";

    addFlashAlert(DANGER, errorMessage);
  }
};

const dispatchContextAction = async (
  taskData: ITaskData,
  model: string,
  actionHandler: string,
  action_payload: any,
) => {
  try {
    const module = await import(`common/reducers/${model}.async.actions`);
    const capitalizedModel = titleCaseString(model).replace(" ", "");
    const action = module[capitalizedModel + "AsyncActions"][actionHandler];
    store.dispatch(action(taskData, action_payload?.toJS()));
  } catch (error: any) {
    console.error("Error in dispatching function dynamically:", error?.message);
  }
};
